export const NAME = "paymentTransactions"
export const FIREBASE_PATH_MESSAGE_LOGS = "messageLogs"
